module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp1_4.f066eb9f.png";